import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=0398e3c8&"
import script from "./NavMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports